var map = {
	"./homepage.de-CH.json": 1371,
	"./homepage.de-DE.json": 1372,
	"./homepage.en-CA.json": 1373,
	"./homepage.en-GB.json": 1374,
	"./homepage.en-IN.json": 1375,
	"./homepage.en-ME.json": 1376,
	"./homepage.en-US.json": 1377,
	"./homepage.es-EM.json": 1378,
	"./homepage.es-ES.json": 1379,
	"./homepage.fr-BE.json": 1380,
	"./homepage.fr-CA.json": 1381,
	"./homepage.fr-CH.json": 1382,
	"./homepage.nl-BE.json": 1383,
	"./homepage.nl-NL.json": 1384,
	"./homepage.pl-PL.json": 1385,
	"./homepage.pt-BR.json": 1386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1370;